import CustomerToolbar from './CustomerToolbar'

export default CustomerToolbar
